import React, { Dispatch, SetStateAction } from 'react';

import HomeIcon from '@mui/icons-material/Home';

export class TydeMenuButton {
  route = '';
  title = '';
  icon: React.FC<any> = () => <HomeIcon fontSize="large" />;
  state?: any | undefined;
  setState?: Dispatch<SetStateAction<any | undefined>>;
  clickHandler?: (item: TydeMenuButton) => void;
}
